
let  table =  {
    /* userList */
    account: 'Account',
    name: 'Name',
    enName: 'Name',
    cnName: 'English Name',
    contact: 'Mobile',
    email: 'Email',
    leverage: 'Leverage',
    opentime: 'Open Time',
    opendate: 'Register Time',
    note: 'Note',
    operate: 'Operate',
    /* accountList */
    username: 'Username',
    role: 'Role',
    superior: 'Superior',
    regtime: 'Register Time',
    lasttime: 'Last Login Time',
    /* clientList */
    countAcc: 'Account Count',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    netdeposit: 'Net Deposit',
    balance: 'Balance',
    commission: 'Commission',
    equity: 'Equity',
    /* positionReport */
    ticket: 'Ticket',
    positionOpentime: 'Open Time',
    type: 'CMD',
    symbol: 'Symbol',
    openprice: 'Open Price',
    stoploss: 'Stop Loss',
    topprofit: 'Top Profit',
    commiss: 'Commission',
    swaps: 'Swaps',
    profit: 'Profit',
    regAddress: 'Location',
    mt4Bala: 'Balance',
    /* userGroupSetting */
    groupMana: 'User Group Management List',
    groupName: 'User Group Name',
    userAuth: 'User Privilege',
    closeTime: 'Close Time',
    orderId: 'Rebate Id',
    accountId: 'Agent Account',
    tradingAccount: 'Trading Account',
    createTime: 'Create Time',
    clientGroup: 'Client Group'

}

export default table;




















































// WEBPACK FOOTER //
// ./src/i18n/english/table.js